<ng-container *transloco="let t">
  @if (selectedVehicles?.length > 0) {
    <section #banner class="container-action-list" [attr.aria-label]="'action list'">
      <div class="action-list-wrapper">
        @if (!isAdmin) {
          <p>{{t('sellModule.manageInventory.actionList.textYouSelected')}} <strong>{{ selectedVehicles.length}} {{t(statusText)}} </strong>
          {{selectedVehicles.length > 1 ? t('sellModule.manageInventory.actionList.textVehicles') : t('sellModule.manageInventory.actionList.textVehicle')}}. {{selectedVehicleTextDisplay}}
        </p>
      } @else {
        <p>{{ selectedVehicleMessage()}}. Choose what you'd like to do with them:</p>
      }
      <div class="action-list-buttons">
        @if (showGenerateReports) {
          <button
            type="button"
            class="btn btn-outline-primary ms-md-3"
            [attr.aria-label]="t('sellModule.manageInventory.actionList.ariaLabelGenerateReports')"
            (click)="generateReport()"
            allytm-click-tagged='false'
            >
            {{t('sellModule.manageInventory.actionList.ariaLabelGenerateReports')}}
          </button>
        }
        @if (isSingleSharedListSelected) {
          <button [attr.allytmln]="'Accept '+ selectedVehicles.length" class="btn btn-outline-primary ms-md-3" type="button" id="accept_all_selected"
            [attr.aria-label]="t('vehicles.sharedListActionBar.ariaLabelBtnAccept')" [attr.data-track-name]="t('vehicles.sharedListActionBar.ariaLabelBtnAccept')"
            (click)="listActionSelected('ACCEPT')">
            {{t('common.btnAccept')}} ({{selectedVehicles.length}})
          </button>
        }
        @if (isSingleSharedListSelected) {
          <button [attr.allytmln]="'Decline '+ selectedVehicles.length" type="button" class="btn btn-outline-primary ms-md-3" id="decline_all_selected"
            [attr.aria-label]="t('vehicles.sharedListActionBar.ariaLabelBtnDecline')" [attr.data-track-name]="t('vehicles.sharedListActionBar.ariaLabelBtnDecline')"
            (click)="listActionSelected('DECLINE')">
            {{t('common.btnDecline')}} ({{selectedVehicles.length}})
          </button>
        }
        @if (isInServiceVehiclesEnabled) {
          @if(showReserved) {
          <button
            type="button"
            class="btn btn-outline-primary ms-md-3"
            [attr.aria-label]="t('sellModule.manageInventory.actionList.ariaLabelReserve')"
            allytm-click-tagged="false"
            (click)="setIsReserved(false)"
            >
            {{t('sellModule.manageInventory.actionList.ariaLabelReserve')}}
          </button>
          }
          @if (showUnreserved) {
            @if(isChangeReservedDealershipEnabled) {
              <button
                type="button"
                class="btn btn-outline-primary ms-md-3"
                [attr.aria-label]="t('sellModule.manageInventory.actionList.ariaLabelChangeReservedDealership')"
                allytm-click-tagged="false"
                (click)="setIsReserved(true)"
                >
                {{t('sellModule.manageInventory.actionList.ariaLabelChangeReservedDealership')}}
              </button>
            }
            <button
              type="button"
              class="btn btn-outline-primary ms-md-3"
              [attr.aria-label]="t('sellModule.manageInventory.actionList.ariaLabelUnreserve')"
              allytm-click-tagged="false"
              (click)="openModal(makeUnreserveModal, analyticsObject.unreserve)"
              >
              {{t('sellModule.manageInventory.actionList.ariaLabelUnreserve')}}
            </button>
          }
        }
        @if (isBulkGroundingEnabled && showGround) {
          <button
            type="button"
            class="btn btn-outline-primary ms-md-3"
            [attr.aria-label]="groundText"
            allytm-click-tagged="false"
            (click)="openGroundingModal(groundingActionModalTemplate, groundingActionEnum.GROUND)"
            >
            {{groundText}}
          </button>
        }
        @if (isBulkGroundingEnabled && showUnground) {
          <button
            type="button"
            class="btn btn-outline-primary ms-md-3"
            [attr.aria-label]="ungroundText"
            allytm-click-tagged="false"
            (click)="openGroundingModal(groundingActionModalTemplate, groundingActionEnum.UNGROUND)"
            >
            {{ungroundText}}
          </button>
        }
        @if (showRemove && removeButtonEnabled) {
          <button
            type="button"
            class="btn btn-outline-primary ms-md-3"
            [attr.aria-label]="t('sellModule.manageInventory.actionList.ariaLabelRemove')"
            allytm-click-tagged="false"
            (click)="openModal(makeRemovedModal, analyticsObject.makeRemoved)"
            >
            {{t('sellModule.manageInventory.actionList.ariaLabelRemove')}}
          </button>
        }
        @if (showMakeActive && makeActiveButtonEnabled) {
          <button
            type="button"
            class="btn btn-outline-primary ms-md-3"
            [attr.aria-label]="t('sellModule.manageInventory.actionList.ariaLabelMakeActive')"
            allytm-click-tagged="false"
            (click)="openModal(makeActiveModal, analyticsObject.makeActive)"
            >
            {{t('sellModule.manageInventory.actionList.ariaLabelMakeActive')}}
          </button>
        }
        @if (showHold && holdButtonEnabled) {
          <button
            type="button"
            class="btn btn-outline-primary ms-md-3"
            [attr.aria-label]="t('sellModule.manageInventory.actionList.ariaLabelHold')"
            allytm-click-tagged="false"
            (click)="openModal(makeHoldModal, analyticsObject.makeHold)"
            >
            {{t('sellModule.manageInventory.actionList.ariaLabelHold')}}
          </button>
        }
        @if (showUpdateSelectedButton) {
          <button
            type="button"
            class="btn btn-outline-primary ms-md-3"
            [attr.aria-label]="t('sellModule.manageInventory.actionList.ariaLabelUpdateSelected')"
            allytm-click-tagged="false"
            (click)="openModal(updateSelectedModal, analyticsObject.updateSelected)"
            >
            {{t('sellModule.manageInventory.actionList.ariaLabelUpdateSelected')}}
          </button>
        }
        @if (showMarkAsArrived && markAsArrivedButtonEnabled) {
          <button
            type="button"
            class="btn btn-outline-primary ms-md-3"
            [attr.aria-label]="t('sellModule.manageInventory.actionList.ariaLabelMarkArrived')"
            allytm-click-tagged="false"
            (click)="openModal(markArrivedModal, analyticsObject.markArrived)"
            >
            {{t('sellModule.manageInventory.actionList.ariaLabelMarkArrived')}}
          </button>
        }
        <button
          type="button"
          class="btn cancel btn-link outline-focus ms-md-2"
          [attr.aria-label]="t('common.btnCancel')"
          (click)="cancel()"
          >
          {{t('common.btnCancel')}}
        </button>
      </div>
    </div>
  </section>
}

<ng-template #makeHoldModal>
  <app-make-hold-modal
    (close)="onModalClose(true)"
    (message)="onModalMessage($event, messageModal)">
  </app-make-hold-modal>
</ng-template>
<ng-template #makeActiveModal>
  <app-make-active-modal
    (close)="onModalClose(true)"
    (message)="onModalMessage($event, messageModal)">
  </app-make-active-modal>
</ng-template>
<ng-template #makeRemovedModal>
  <app-make-removed-modal
    (close)="onModalClose(true)"
    (message)="onModalMessage($event, messageModal)">
  </app-make-removed-modal>
</ng-template>
<ng-template #markArrivedModal>
  <app-mark-arrived-modal
    (close)="onModalClose(true)"
    (arrived)="openModal(arrivedSuccessModal, analyticsObject.markArrivedSuccess)"
    (error)="onModalError($event, errorModal)">
  </app-mark-arrived-modal>
</ng-template>
<ng-template #errorModal>
  <app-action-list-error-modal
    (close)="onModalClose(true)"
    [errorMessage]="modalError">
  </app-action-list-error-modal>
</ng-template>
<ng-template #messageModal>
  <app-action-list-message-modal
    (close)="onModalClose(true)"
    [messages]="modalMessage">
  </app-action-list-message-modal>
</ng-template>
<ng-template #arrivedSuccessModal>
  <app-mark-arrived-success-modal
    (close)="onModalClose(true)">
  </app-mark-arrived-success-modal>
</ng-template>
<ng-template #updateSelectedModal>
  <app-update-selected-modal
    [multipleTenantsSelected]="areMultipleTenantsSelected"
    (close)="onModalClose(true)"
    (message)="onModalMessage($event, messageModal)">
  </app-update-selected-modal>
</ng-template>
  <ng-template #makeReserveModal>
    <app-make-reserve-modal
      [numberOfVehicles]="this.selectedVehicles.length"
      [isReserved]="isReserved"
      (close)="onModalClose(true)"
      (message)="onModalMessage($event, messageModal)">
    </app-make-reserve-modal>
  </ng-template>
  <ng-template #makeUnreserveModal>
    <app-make-unreserve-modal
      [numberOfVehicles]="this.selectedVehicles.length"
      (close)="onModalClose(true)"
      (message)="onModalMessage($event, messageModal)">
    </app-make-unreserve-modal>
  </ng-template>
  <ng-template #groundingActionModalTemplate>
    <app-multi-result-modal #groundingActionModal
      [templateContent]="multiResultModalContent"
      [isLoading]="isGroundingModalLoading"
      [modalTemplateLabels]="groundingModalLabels"
      (close$)="onMultiResultModalClose($event)"
      (selectFailed$)="selectFailedAndCloseModal($event)"
      (resetGroundingModalTemplate$)="resetGroundingModalTemplate($event)"
    >
  </app-multi-result-modal>
</ng-template>
<app-error-modal></app-error-modal>
</ng-container>
